import { TicketsCounters } from "@services/tickets/types";
import { useTranslation } from "react-i18next";

export const useTicketsFormatter = () => {
  const { t } = useTranslation();

  const getRealtimeTickets = (tickets: TicketsCounters) => {
    const path = "/tickets?status=Open";
    const dataTicket: RealTimeTicketProps = {
      realTimeCard: {
        dataType: t("open tickets"),
        loading: false,
        // TO REMOVE : when we will be able to create ticket from everywhere
        // button: {
        //   color: "ticket",
        // },
      },
      data: [
        {
          label: {
            text: t("critical"),
            color: "ticket.Critical",
          },
          data: tickets.ticketsCritical,
          url: `${path}&priority=Critical`,
        },
        {
          label: {
            text: t("major"),
            color: "ticket.Major",
          },
          data: tickets.ticketsMajor,
          url: `${path}&priority=Major`,
        },
        {
          label: {
            text: t("minor"),
            color: "ticket.Minor",
          },
          data: tickets.ticketsMinor,
          url: `${path}&priority=Minor`,
        },
      ],
    };
    return dataTicket;
  };

  return { getRealtimeTickets };
};
